module.exports = __webpack_public_path__ + "2cc66e18b298601839cdd2735b38d3e9.MP3";